import { render, staticRenderFns } from "./UsePolicy.vue?vue&type=template&id=c3449572&scoped=true"
import script from "./UsePolicy.vue?vue&type=script&lang=ts"
export * from "./UsePolicy.vue?vue&type=script&lang=ts"
import style0 from "./UsePolicy.vue?vue&type=style&index=0&id=c3449572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3449572",
  null
  
)

export default component.exports